//
// Copyright 2026 DXOS.org
//

export { default, discoveryKey, keyPair, randomBytes, sign, validateKeyPair, verify } from 'hypercore-crypto';
